var _defs, _mask, _use, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1624px",
    height: "148px",
    viewBox: "0 0 1624 148",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1624,
    height: 148,
    rx: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92FEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#677EFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB5EF",
    stopOpacity: 0.48008632,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE67FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "104.000598%",
    y2: "50.623647%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B8FB",
    stopOpacity: 0.911919248,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0076EF",
    stopOpacity: 0.681517701,
    offset: "56.6348391%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E34FF",
    stopOpacity: 0.745110358,
    offset: "99.9289773%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "104.000598%",
    y2: "50.623647%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6399FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0021EF",
    stopOpacity: 0.681517701,
    offset: "48.7434441%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7534FF",
    stopOpacity: 0.29526333,
    offset: "99.9289773%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.7799597%",
    y1: "122.781157%",
    x2: "104.000598%",
    y2: "50.623647%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0021E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088EF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-59.2%",
    y: "-59.1%",
    width: "218.4%",
    height: "218.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.9455502%",
    y1: "38.3385451%",
    x2: "63.2652796%",
    y2: "75.7507002%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C0DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144FE2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "47.3673672%",
    x2: "80.7319728%",
    y2: "60.4514997%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002485",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001EA1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.1664214%",
    y1: "29.7215873%",
    x2: "98.5501012%",
    y2: "56.5305921%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EFFF1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1548FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.7323241%",
    y1: "20.0459216%",
    x2: "-10.7191017%",
    y2: "76.8111655%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.4595085%",
    y1: "57.2946487%",
    x2: "99.715635%",
    y2: "35.5792606%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.499125874,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-36.2%",
    width: "138.9%",
    height: "172.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.4595085%",
    y1: "57.2946487%",
    x2: "99.715635%",
    y2: "35.5792606%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.608801355,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0000002%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2099FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33E6FF",
    offset: "47.6781352%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D573FF",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1_\\u6A21\\u578B\\u4E2D\\u5FC3_\\u65E0\\u6A21\\u578B",
    transform: "translate(-265.000000, -110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(265.000000, 110.000000)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#001A61",
    xlinkHref: "#path-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.680922,64.9739396 C545.153591,64.7042211 549.808715,68.9220457 550.078434,74.3947145 C550.086451,74.5573805 550.090461,74.7202194 550.090461,74.8830829 L550.090461,155.038736 C550.090461,160.875917 545.511027,165.686605 539.680922,165.97394 C534.208253,166.243658 529.553129,162.025833 529.28341,156.553165 C529.275393,156.390499 529.271383,156.22766 529.271383,156.064796 L529.271383,75.9091433 C529.271383,70.0719623 533.850817,65.2612741 539.680922,64.9739396 Z",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    transform: "translate(539.680922, 115.473940) rotate(20.000000) translate(-539.680922, -115.473940) "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.48337,26.4597589 L1071.22668,26.4231254 C1079.16538,26.0318693 1085.91815,32.1502868 1086.30941,40.0889935 C1086.32104,40.3249585 1086.32685,40.5611741 1086.32685,40.7974255 L1086.32685,157.816205 C1086.32685,165.866867 1080.01088,172.501786 1071.96998,172.898079 L1071.22668,172.934712 C1063.28797,173.325968 1056.5352,167.207551 1056.14394,159.268844 C1056.13231,159.032879 1056.1265,158.796663 1056.1265,158.560412 L1056.1265,41.5416322 C1056.1265,33.4909706 1062.44247,26.8560517 1070.48337,26.4597589 Z",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-4)",
    mask: "url(#mask-2)",
    transform: "translate(1071.226675, 99.678919) rotate(20.000000) translate(-1071.226675, -99.678919) "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.29363,-35.2699025 C1364.20925,-35.2699025 1378.75523,-20.7067132 1378.75523,-2.76990254 C1378.75523,15.1669081 1364.20925,29.7300975 1346.29363,29.7300975 C1328.37802,29.7300975 1313.83204,15.1669081 1313.83204,-2.76990254 C1313.83204,-20.7067132 1328.37802,-35.2699025 1346.29363,-35.2699025 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero",
    opacity: 0.163222202,
    mask: "url(#mask-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.73278,46.7300975 C342.037757,46.7300975 379.633524,84.3703407 379.633524,130.730097 C379.633524,177.089854 342.037757,214.730097 295.73278,214.730097 C249.427802,214.730097 211.832035,177.089854 211.832035,130.730097 C211.832035,84.3703407 249.427802,46.7300975 295.73278,46.7300975 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    opacity: 0.593545603,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(399.598608, -39.757035)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3174094,8.4871329 C73.0955396,8.4871329 92.4013917,27.8158241 92.4013917,51.6220842 C92.4013917,75.4283443 73.0955396,94.7570354 49.3174094,94.7570354 C25.5392791,94.7570354 6.23342706,75.4283443 6.23342706,51.6220842 C6.23342706,27.8158241 25.5392791,8.4871329 49.3174094,8.4871329 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    filter: "url(#filter-8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3174094,8.4871329 C73.0955396,8.4871329 92.4013917,27.8158241 92.4013917,51.6220842 C92.4013917,75.4283443 73.0955396,94.7570354 49.3174094,94.7570354 C25.5392791,94.7570354 6.23342706,75.4283443 6.23342706,51.6220842 C6.23342706,27.8158241 25.5392791,8.4871329 49.3174094,8.4871329 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(49.021659, 52.114393) rotate(86.000000) translate(-49.021659, -52.114393) translate(-0.023512, 6.402600)",
    fillOpacity: 0,
    opacity: 0.398369368
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    },
    transform: "translate(49.045171, 45.711793) rotate(-41.701001) translate(-49.045171, -45.711793) translate(-4.991615, 32.634066)",
    fill: "#000000",
    fillRule: "nonzero",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4900685,0.761241043 C103.343658,3.44804041 108.073571,6.90849489 108.073571,10.6826782 C108.073571,19.2221032 83.8596865,26.1554539 54.0367855,26.1554539 C24.2138845,26.1554539 -6.82121026e-13,19.2221032 -6.82121026e-13,10.6826782 C-6.82121026e-13,6.79521096 5.01811579,3.24058862 13.2990896,0.521407754"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Architecture---Pragmas-architecture-has-3-key-pillars---its-scalable,",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1160.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.396445,21.9614391 C110.593089,3.34618697 57.4080633,3.34618697 24.6035643,21.9614391 C8.15674346,31.2954747 -0.0455241577,43.5368516 0,55.7690426 L0.00247573641,81.0061896 C-0.14495251,93.3141644 8.05617225,105.6474 24.6035643,115.0377 C57.4069205,133.6541 110.591946,133.6541 143.396445,115.0377 C159.943837,105.6474 168.144962,93.3130161 167.997534,81.0061896 L168,55.7690426 C168.044391,43.5357034 159.843266,31.2954747 143.396445,21.9614391 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.396571,22.0584249 C176.201143,40.8045219 176.201143,71.196339 143.396571,89.9412881 C110.593143,108.686237 57.408,108.686237 24.6034286,89.9412881 C-8.20114286,71.196339 -8.20114286,40.8033741 24.6034286,22.0595727 C57.4068571,3.31347575 110.592,3.31347575 143.396571,22.0595727 L143.396571,22.0584249 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    opacity: 0.8,
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(30.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9236005,2.49156889 L35.9602222,2.49156889 C49.0559138,-2.27926085 66.349368,0.00704982938 74.5846731,7.59082531 L75.0355778,8.01950856 C85.9396895,6.88902934 97.4377594,9.59019478 103.696637,15.3543712 C111.708779,22.733024 108.197673,32.4025971 95.9511472,37.3151688 C101.592034,42.5388817 100.502538,49.5015274 92.663205,54.0407299 C83.548979,59.3197567 68.7698336,59.3197567 59.6556076,54.0407299 L6.8356695,23.453258 C-2.2785565,18.1742312 -2.2785565,9.61554701 6.8356695,4.33536782 C14.7230685,-0.260301016 26.8894844,-0.868754663 35.9236005,2.49156889 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.9191753,2.49476393 L65.9558392,2.49476393 C79.0517299,-2.28188807 96.3456384,0.00630089149 104.581269,7.60175307 L105.03384,8.03107625 C115.937916,6.89849178 127.436635,9.60449391 133.695852,15.3767613 C136.781349,18.2220345 138.158537,21.4080039 137.985529,24.5318192 L137.985529,53.3989113 C138.282278,58.7487615 134.006349,64.0468167 125.949455,67.2834301 C131.591114,72.5147273 130.501509,79.4874882 122.662306,84.0350911 C113.547887,89.3216363 98.7666022,89.3216363 89.6533289,84.0350911 L36.8286534,53.3989113 C32.4255469,50.8459922 30.1489471,47.5253558 30,44.1793974 L30,13.5616336 C30.1489471,10.2156752 32.4255469,6.89503878 36.8286534,4.34211971 C44.717123,-0.261882221 56.8838127,-0.871912476 65.9191753,2.49476393 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.923788,2.49090673 L65.9604493,2.49090673 C79.0554111,-2.27836 96.3492386,0.00629114957 104.584285,7.58999986 L105.036824,8.01865926 C115.940126,6.88782589 127.436884,9.58964423 133.696803,15.352987 C141.708445,22.7309852 138.198124,32.4016791 125.950955,37.3145984 C131.592215,42.5378074 130.502686,49.4997876 122.66404,54.0403594 C113.549122,59.3198802 98.7700308,59.3198802 89.6562581,54.0403594 L36.8353295,23.4515467 C27.7215568,18.1731751 27.7215568,9.61492709 36.8353295,4.33540628 C44.7243852,-0.26147732 56.8902119,-0.870564397 65.923788,2.49090673 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-13)",
    fillRule: "nonzero",
    filter: "url(#filter-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.923788,2.49090673 L65.9604493,2.49090673 C79.0554111,-2.27836 96.3492386,0.00629114957 104.584285,7.58999986 L105.036824,8.01865926 C115.940126,6.88782589 127.436884,9.58964423 133.696803,15.352987 C141.708445,22.7309852 138.198124,32.4016791 125.950955,37.3145984 C131.592215,42.5378074 130.502686,49.4997876 122.66404,54.0403594 C113.549122,59.3198802 98.7700308,59.3198802 89.6562581,54.0403594 L36.8353295,23.4515467 C27.7215568,18.1731751 27.7215568,9.61492709 36.8353295,4.33540628 C44.7243852,-0.26147732 56.8902119,-0.870564397 65.923788,2.49090673 Z",
    id: "\\u8DEF\\u5F84",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\u914D\\u7F6E\\u6A21\\u578B->-\\u5BFC\\u5165\\u6570\\u636E->-\\u751F\\u6210\\u5185\\u5BB9",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fontFamily: "AlibabaPuHuiTi-Regular, Alibaba PuHuiTi",
    fontSize: 16,
    fontWeight: "normal",
    "line-spacing": 32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 700.028329,
    y: 96.0229005
  }, "\u914D\u7F6E\u6A21\u578B &gt; \u5BFC\u5165\u6570\u636E &gt; \u751F\u6210\u5185\u5BB9"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "\\u4EC5\\u97002\\u6B65-\\u8F7B\\u677E\\u521B\\u5EFA\\u81EA\\u6709\\u6A21\\u578B",
    fill: "url(#linearGradient-16)",
    fillRule: "nonzero",
    fontFamily: "AlibabaPuHuiTi-Bold, Alibaba PuHuiTi",
    fontSize: 28,
    fontWeight: "bold",
    "line-spacing": 32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 648.5,
    y: 67
  }, "\u4EC5\u97002\u6B65 \u8F7B\u677E\u521B\u5EFA\u81EA\u6709\u6A21\u578B")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelEmpty);
export default __webpack_public_path__ + "static/media/model_Empty.77f12e7b8d1aff1749980fc6a4e62de9.svg";
export { ForwardRef as ReactComponent };